import IPFSGatewayTools from '@pinata/ipfs-gateway-tools/dist/browser';
const ipfsGatewayTools = new IPFSGatewayTools();



export const getIpfsUrl = (hash) => ipfsGatewayTools.convertToDesiredGateway(hash, process.env.REACT_APP_IPFS_GATEWAY_PREFIX)
